import React, { useState, useEffect } from "react";
import Lottie from 'lottie-react';
import downloadLottie from '../../media/lotties/download.json';


const DocumentDownload = ({ downloadQueue }) => {
  return (
    <div className="document-download__loader-wrapper">
        {Object.values(downloadQueue)?.map((item) => (
          <div className="document-download__loader">
            <div className="document-download__loader-icon">
              <Lottie
                animationData={downloadLottie}
                loop
              />
            </div>
            <div className="document-download__loader-text">
              {item?.document_count ? `Downloading ${item?.document_count} ${item?.document_type?.replaceAll('_', ' ')?.toProperCase()}..` : ''}
              {item?.document_number ? `Downloading ${item?.document_type?.replaceAll('_', ' ')?.toProperCase()}..` : ''}
            </div>
          </div>
        ))}
      </div>
  );
};

export default DocumentDownload;
